import dayjs from 'dayjs';

// Модуль для работы с датами

export const format = (date: Date | string): string => dayjs(date).locale('ru').format('D MMMM YYYY HH:mm');
